import React, { useEffect, useState } from "react";
import "../style.scss";
import Sidebar from "..";

const SlideSideBar = () => {

  const [isSideBarOpen, setSideBarOpen] = useState(false);

  const toggleSideBarView = () => {
    setSideBarOpen(!isSideBarOpen)
  }

  return(
    <>
      <div onClick={toggleSideBarView} className="d-flex flex-item m-l-12" style={{width:"55px", height:"55px", borderRadius:"20px", zIndex: isSideBarOpen && 4, backgroundColor: isSideBarOpen ? "#E33A34" : "#ffffff", transition:"180ms"}}>
        {
          isSideBarOpen ? (
            <svg className="flex-item margin-auto" width="22" height="22" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 14L14 1M14 14L1 1" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          ) : (
            <svg className="flex-item margin-auto" width="25" height="25" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 12C0.71667 12 0.479337 11.904 0.288004 11.712C0.0966702 11.52 0.000670115 11.2827 3.44827e-06 11C-0.000663218 10.7173 0.0953369 10.48 0.288004 10.288C0.48067 10.096 0.718003 10 1 10H17C17.2833 10 17.521 10.096 17.713 10.288C17.905 10.48 18.0007 10.7173 18 11C17.9993 11.2827 17.9033 11.5203 17.712 11.713C17.5207 11.9057 17.2833 12.0013 17 12H1ZM1 7C0.71667 7 0.479337 6.904 0.288004 6.712C0.0966702 6.52 0.000670115 6.28267 3.44827e-06 6C-0.000663218 5.71733 0.0953369 5.48 0.288004 5.288C0.48067 5.096 0.718003 5 1 5H17C17.2833 5 17.521 5.096 17.713 5.288C17.905 5.48 18.0007 5.71733 18 6C17.9993 6.28267 17.9033 6.52033 17.712 6.713C17.5207 6.90567 17.2833 7.00133 17 7H1ZM1 2C0.71667 2 0.479337 1.904 0.288004 1.712C0.0966702 1.52 0.000670115 1.28267 3.44827e-06 1C-0.000663218 0.717333 0.0953369 0.48 0.288004 0.288C0.48067 0.0960001 0.718003 0 1 0H17C17.2833 0 17.521 0.0960001 17.713 0.288C17.905 0.48 18.0007 0.717333 18 1C17.9993 1.28267 17.9033 1.52033 17.712 1.713C17.5207 1.90567 17.2833 2.00133 17 2H1Z" fill="#9a9a9a"/>
            </svg>
          )
        }
        
      </div>
      {
        isSideBarOpen && (
          <div className="slide-side-bar-container" style={{width:"100%", height:"100%"}}>
            <Sidebar closeSidebar={toggleSideBarView}/>
          </div>
        )
      }
    </>
  )
}

export default SlideSideBar;